import { useQuery } from '@tanstack/react-query';
import type { PageTrafficPrompt } from '@brand24-original/llm-types';
import { getPageTrafficPrompts } from '../../../../../services/monitor/data/sources/MonitorDataSourcesService';
import { ChatType } from '../../../../../types/monitor/ChatType';

export const GET_PAGE_TRAFFIC_PROMPTS = 'page-traffic-prompts';

/** Prompts citing one URL of the URL Overview table. Mounted only inside an expanded row, so the
 *  request fires on expand; cached per URL + filters, so collapsing and re-expanding is free. */
export const useGetPageTrafficPrompts = (
  projectId: number,
  source: string,
  chatType: ChatType | null,
  from: Date | null,
  to: Date | null,
  monitorPromptIds?: number[],
  filterMonitorTypes?: string[]
) => {
  const queryEnabled = !!projectId && !!source && !!chatType && !!from && !!to;

  const fromTimestamp = from?.getTime() ?? null;
  const toTimestamp = to?.getTime() ?? null;

  const { data, isLoading } = useQuery<PageTrafficPrompt[]>({
    queryKey: [
      GET_PAGE_TRAFFIC_PROMPTS,
      projectId,
      source,
      chatType,
      fromTimestamp,
      toTimestamp,
      monitorPromptIds,
      filterMonitorTypes,
    ],
    queryFn: () =>
      getPageTrafficPrompts(
        projectId,
        source,
        chatType!,
        from,
        to,
        monitorPromptIds,
        filterMonitorTypes
      ),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: queryEnabled,
  });

  return {
    prompts: queryEnabled ? data ?? [] : [],
    isLoading: queryEnabled ? isLoading : false,
  };
};
